"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolsCutSide = exports.ToolsCutDirection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
var ToolsCutDirection;
(function (ToolsCutDirection) {
    ToolsCutDirection[ToolsCutDirection["Left"] = 0] = "Left";
    ToolsCutDirection[ToolsCutDirection["Right"] = 1] = "Right";
})(ToolsCutDirection || (exports.ToolsCutDirection = ToolsCutDirection = {}));
var ToolsCutSide;
(function (ToolsCutSide) {
    ToolsCutSide[ToolsCutSide["Left"] = 0] = "Left";
    ToolsCutSide[ToolsCutSide["Right"] = 1] = "Right";
})(ToolsCutSide || (exports.ToolsCutSide = ToolsCutSide = {}));
function ToolsCutSideButton({ position, angle = 0, direction = ToolsCutDirection.Left, className, onCut = () => { }, }) {
    const topButtonRef = (0, react_1.useRef)(null);
    const botomButtonRef = (0, react_1.useRef)(null);
    const onCutTop = (event) => {
        event.stopPropagation();
        onCut(ToolsCutSide.Left);
    };
    const onCutBottom = (event) => {
        event.stopPropagation();
        onCut(ToolsCutSide.Right);
    };
    const events = (0, ui_1.getPointersEvents)();
    (0, ui_1.useEvent)(topButtonRef, events.down, onCutTop);
    (0, ui_1.useEvent)(botomButtonRef, events.down, onCutBottom);
    if (!position) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(Container, { position: position, angle: angle, direction: direction, className: className, role: "dialog", "data-e2e": 'ToolsCutSideButton_Container', children: [(0, jsx_runtime_1.jsx)(Button, { ref: topButtonRef, "data-e2e": 'ToolsCutSideButton_Button', children: (0, jsx_runtime_1.jsx)(ButtonIcon, { name: ui_1.Icons.Tools_Cut_Icon, "data-e2e": 'ToolsCutSideButton_ButtonIcon' }) }), (0, jsx_runtime_1.jsx)(Button, { ref: botomButtonRef, "data-e2e": 'ToolsCutSideButton_Button', children: (0, jsx_runtime_1.jsx)(ButtonIcon, { name: ui_1.Icons.Tools_Cut_Icon, "data-e2e": 'ToolsCutSideButton_ButtonIcon' }) })] }));
}
exports.default = ToolsCutSideButton;
const Container = styled_components_1.default.div `
  position: absolute;
  top: ${({ position }) => position.y}px;
  left: ${({ position }) => position.x}px;

  display: flex;
  flex-direction: column;

  transform: translate(-50%, -50%) rotate(${({ angle }) => angle}deg)
    scaleX(
      ${({ direction }) => (direction === ToolsCutDirection.Right ? 1 : -1)}
    );

  pointer-events: all;
`;
const Button = styled_components_1.default.div.attrs({ role: 'button' }) `
  display: flex;
  align-items: center;

  width: 45px;
  height: 45px;

  margin: 10px 0;
  padding: 0;

  color: ${({ theme }) => theme.gray};

  background: ${({ theme }) => theme.white};

  border-radius: 50%;

  cursor: pointer;
`;
const ButtonIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 25px;
  height: 25px;

  margin: auto;
`;
